<div class="flex flex-col p-6 gap-5">
  <ep-breadcrumbs>
    <ep-breadcrumb [routerLink]="['/']"><span>Realm</span></ep-breadcrumb>
    <ep-breadcrumb><span>My Client Requests</span></ep-breadcrumb>
  </ep-breadcrumbs>

  <div class="flex items-center justify-between">
    <h1>My Client Requests</h1>
    @if (!isLoading() && requests().length > 0) {
      <ep-button color="primary" [routerLink]="['/clients/request']">Request a Client</ep-button>
    }
  </div>

  @if (isLoading() || loadError()) {
    <app-load-status [error]="loadError()" loadingLabel="Loading client requests" />
  } @else if (requests().length === 0) {
    <div class="flex flex-col items-center gap-3 py-8 text-center">
      <div
        class="rounded-full p-4 bg-bg-primary-default text-fg-primary-bolder flex items-center justify-center"
      >
        <svg class="icon icon--medium" viewBox="0 -960 960 960" fill="currentColor">
          <path
            d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-120H640q-30 38-71.5 59T480-240q-47 0-88.5-21T320-320H200v120Zm280-120q38 0 69-22t43-58h168v-360H200v360h168q12 36 43 58t69 22ZM200-200h560-560Z"
          />
        </svg>
      </div>
      <h6>No client requests yet</h6>
      <p class="body-sm text-fg-subtle">
        Request a client and a realm admin will review and create it for you.
      </p>
      <ep-button color="primary" [routerLink]="['/clients/request']">Request a Client</ep-button>
    </div>
  } @else {
    <div class="flex flex-col gap-3">
      @for (request of requests(); track request.id) {
        <app-client-request-card [request]="request" />
      }
    </div>
  }
</div>
